import { BlankLayout } from '@/components/layouts';

export default {
  path: '/score-market',
  name: 'Score.Market',
  component: BlankLayout,
  meta: { module: '积分' },
  children: [
    {
      path: '/score-market/draw',
      name: 'Score.Market.Draw',
      component: () => import(/* webpackChunkNameL: 'score-market-draw' */ '../../views/score-market/ScoreDraw.vue'),
      meta: { title: '积分抽奖', hideBanner: true },
    },
    {
      path: '/score-market/rules',
      name: 'Score.Market.Rules',
      component: () => import(/* webpackChunkNameL: 'score-market-rules' */ '../../views/score-market/ScoreRules.vue'),
      meta: { title: '积分规则', hideBanner: true },
    },
  ],
};
